import { observer } from "mobx-react-lite";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { markdownText } from "./text";

export const MarkdownGuide = observer(() => {
  return <Markdown remarkPlugins={[remarkGfm]}>{markdownText}</Markdown>;
});
